<template>
    <MediaWithCaption
        kind="image"
        :asset-id="content?.image"
        :content="{ text: content?.text, sticky: content?.sticky }"
    />
</template>

<script lang="ts" setup>
import MediaWithCaption from "~/components/view/MediaWithCaption.vue"

defineProps({
    content: {
        type: Object as PropType<{image: string, text?: unknown, sticky?: boolean, priority?: boolean}>,
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})
</script>
